import {
  PageEnvironmentVariables,
  subscribe,
  type PageEnvironmentConnectionState,
} from '@seamless/one-context';
import { mapAntarcticaMarket } from './aemData';

export async function getEnvData(): Promise<PageEnvironmentConnectionState> {
  return new Promise((resolve) => {
    subscribe<PageEnvironmentConnectionState>('PageConnection', {
      tenant: 'owvans',
      componentName: 'technical-data',
      callback: resolve,
    });
  });
}

export async function getPageEnvironmentVariables() {
  const envData = (await getEnvData())
    .pageEnvironmentVariables as PageEnvironmentVariables;

  const getLocale = `${envData.language}-${envData.country}`;
  const localeMappings: Record<string, string> = {
    'de-AQ': 'de-DE',
    'en-AQ': 'en-DE',
  };

  return {
    modelSeries: envData.vehicleData.modelSeries,
    stage: envData.stage,
    language: envData.language,
    country: mapAntarcticaMarket(envData.country, envData.language),
    locale: localeMappings[getLocale] || getLocale,
  };
}
